import Types from './type';

const decimalAdd = (augend, addend, augendFlag, addendFlag) => {
    const len1 = augend.length;
    const len2 = addend.length;
    // 全为0，返回0
    if (len1 === len2 && len1 === 0) {
        return [0, 0];
    }
    // 其中一个为0，并且符号相同 或者 为0的值为负号
    if (((len1 === 0 || len2 === 0) && augendFlag === addendFlag) || (len1 === 0 && augendFlag) || (len2 === 0 && addendFlag)) {
        return [0, len1 > len2 ? augend : addend];
    }
    // 获取位数较多的
    const len = len1 >= len2 ? len1 : len2;
    augend = augend.padEnd(len, 0);
    addend = addend.padEnd(len, 0);
    // 处理借位的情况
    let takeFlag = false; // 借位标识
    if (augendFlag && !addendFlag) {
        if (augend > addend) {
            addend = +`1${addend}`;
            takeFlag = true;
        }
        augend = -augend;
    }
    if (addendFlag && !augendFlag) {
        if (augend < addend) {
            augend = +`1${augend}`;
            takeFlag = true;
        }
        addend = -addend;
    }
    const result = `${+augend + +addend}`;
    // 注意小数部分返回字符串，因为会有0xxx的情况
    return [takeFlag ? -1 : +result.substring(0, result.length - len), result.substring(result.length - len)];
};

// 加法
export const add = (augend, addend) => {
    if (!Types.number(augend) || !Types.number(addend)) {
        return NaN;
    }
    // 负号标识
    let augendFlag = false;
    let addendFlag = false;
    if (+augend < 0) {
        augendFlag = true;
    }
    if (+addend < 0) {
        addendFlag = true;
    }
    // 结果变更标识
    let takeFlag = false;
    // 负数较大，提取负号
    if ((augendFlag && !addendFlag && -augend > addend) || (addendFlag && !addendFlag - addend > augend)) {
        addend = -addend;
        augend = -augend;
        augendFlag = !augendFlag;
        addendFlag = !addendFlag;
        takeFlag = true;
    }
    // 处理相加的数字为字符串换并划分整数和小数部分
    const augendArr = `${augend}`.split('.');
    const addendArr = `${addend}`.split('.');
    const result = +augendArr[0] + +addendArr[0]; // 整数部分直接相加
    // 小数部分相加获得整数进位和小数部分
    const [over, base] = decimalAdd(augendArr[1] || '', addendArr[1] || '', augendFlag, addendFlag);
    if (takeFlag) {
        return -`${result + over}.${base}`;
    }
    return +`${result + over}.${base}`;
};

// 乘法
export const multiply = (multiplier, multiplicand) => {
    if (!Types.number(multiplier) || !Types.number(multiplicand)) {
        return NaN;
    }
    multiplier = +multiplier;
    multiplicand = +multiplicand;
    if (multiplier === 0 || multiplicand === 0) {
        return 0;
    }
    // 负号标识
    let multiplierFlag = false;
    let multiplicandFlag = false;
    // 处理成正数，计算后再加符号
    if (multiplier < 0) {
        multiplierFlag = true;
        multiplier = -multiplier;
    }
    if (multiplicand < 0) {
        multiplicandFlag = true;
        multiplicand = -multiplicand;
    }
    multiplier = `${multiplier}`;
    multiplicand = `${multiplicand}`;
    // 化为整数相乘再添加小数点
    const multiplierDecimal = multiplier.split('.')[1] || '';
    const multiplicandDecimal = multiplicand.split('.')[1] || '';
    // 记录小数的位数
    const decimalLen = multiplierDecimal.length + multiplicandDecimal.length;
    // 整数相乘
    let result = `${multiplier.replace('.', '') * multiplicand.replace('.', '')}`;
    // 加小数点
    if (decimalLen >= result.length) {
        // 整数位不够，左边填0补齐
        result = `0.${result.padStart(decimalLen, '0')}`;
    } else if (decimalLen !== 0) {
        result = `${result.substring(0, result.length - decimalLen) || 0}.${result.substring(result.length - decimalLen) || 0}`;
    }
    // 加符号
    if (multiplierFlag === multiplicandFlag) {
        return +result;
    }
    return -result;
};
